import styled from 'styled-components';

export const MyJobsContainerStyled = styled.div`
  margin-top: 18px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 30px 20px;

  & .table-container {
    margin-bottom: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    background-color: ${({ theme }) => theme.colors.lighterBackground};
  }
`;
